(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["molli-b2b-form"] && !Shopify.designMode) return;
  try {
    (function () {
    const forms = document.querySelectorAll('.molli-b2b-block__form, .molli-b2b__form');
    if (!forms.length) return;
    forms.forEach(function (form) {
      if (form.__b2bBound) return;
      form.__b2bBound = true;
      const noteInput = form.querySelector('[data-b2b-note]');
      if (!noteInput) return;
      form.addEventListener('submit', function () {
        const fields = form.querySelectorAll('[data-b2b-field]');
        const parts = [];
        fields.forEach(function (el) {
          const label = el.getAttribute('data-b2b-field');
          const value = (el.value || '').trim();
          if (value) parts.push(label + ': ' + value);
        });
        noteInput.value = parts.join('\n');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nuvos-collapsible"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-nuvos-collapsible]').forEach(function (list) {
      var triggers = list.querySelectorAll('.nuvos-collapsible__trigger');

      function close(item) {
        item.classList.remove('is-open');
        var btn = item.querySelector('.nuvos-collapsible__trigger');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
      function open(item) {
        item.classList.add('is-open');
        var btn = item.querySelector('.nuvos-collapsible__trigger');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      }

      triggers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.nuvos-collapsible__item');
          if (!item) return;
          var wasOpen = item.classList.contains('is-open');
          // Accordion: close every open row in this list first.
          list.querySelectorAll('.nuvos-collapsible__item.is-open').forEach(close);
          if (!wasOpen) open(item);
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
